import React, { Component } from 'react';
import { connect } from 'react-redux';

import OneLineSearch from '../Search/OneLineSearch'

import Translations from "../../translations/translations.json";
import HeroBg from "../../assets/backgrounds/hero-kayak.jpg";

class Hero extends Component {
    render() {
        return (
            <div className="hero__main">
                <div className="hero__container">
                    <img src={HeroBg} className="hero__background" alt="Hero Background" />
                    <div className="hero__overlay"></div>
                    <div className="hero__cta__container">
                        <h4 className="rides-title hero__title">Vivez l'expérience récréative de vos rêves!</h4>
                        <OneLineSearch />
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    lang: state.lang
});
export default connect(mapStateToProps)(Hero);